import { put, select } from 'redux-saga/effects';
import { AUTOMATION_SOURCE } from 'utils/constants';
import { selectFormById } from '../../formControlSelectors';
import { formControlActions } from '../../formControlSlice';
import { resolveConditionalValue } from '../../lib/copyToFormHelpers';

export function* copyConditionalsAutofillHandler({ payload: { transactionId, autofilledFields } }) {
    if (!autofilledFields || autofilledFields.length === 0) return;

    const form = yield select(selectFormById(transactionId));
    if (!form) return;

    const fields = form?.formConfig?.fields || [];
    const userEdited = form?.form?.userEdited || {};
    const currentValues = form?.form?.values || {};

    for (const { field, value } of autofilledFields) {
        if (value === undefined || value === null || value === '') continue;

        // Skip fields the user has manually edited, UNLESS the user has cleared
        // the field (empty input). Clearing the field is treated as an explicit
        // request to let the validate endpoint autofill it again.
        const currentValue = currentValues[field];
        const isFieldEmpty = currentValue === undefined || currentValue === null || currentValue === '';
        if (userEdited[field] && !isFieldEmpty) continue;

        const fieldConfig = fields.find((f) => f.dataField === field);
        const finalValue = resolveConditionalValue(value, fieldConfig?.lookup);
        yield put(formControlActions.setFieldValue({ formId: transactionId, fieldName: field, value: finalValue }));
        yield put(formControlActions.setFieldValueSource({ formId: transactionId, fieldName: field, source: AUTOMATION_SOURCE.CONDITIONALS }));
        yield put(formControlActions.setFieldError({ formId: transactionId, fieldName: field, error: false }));
        yield put(formControlActions.clearSheetAnnouncementValue({ formId: transactionId, fieldName: field }));

        // The field is now system-owned (autofilled), not the agent's manual value. If the agent had
        // previously edited/cleared it, clear that userEdited flag so it is no longer treated as a
        // manual value: it can be auto-reverted when the trigger changes (e.g. Cargo Status -> Loaded)
        // and it shows the "Autofilled" pill. Without this, a field the agent cleared and the system
        // then re-autofilled would keep userEdited=true and never revert.
        if (userEdited[field]) {
            yield put(formControlActions.clearUserEdited({ formId: transactionId, fieldName: field }));
        }
    }
}
